// Copyright 2018 Sorama B.V.

import { Unit, UnitType } from "units/Unit";

export class AcousticIntensity extends UnitType {
    public static override typeName = "Intensity";

    public static Intensity: Unit = new Unit("W/m²", 1, AcousticIntensity);
}
